import Http from '@/utils/http'
const baseUrl = '/app/teacher'

/**
 * 班级列表
 * 
*/

export const classList = () => Http.get(`${baseUrl}/class`)

/**
 * 创建班级
 * @param params
 * 
*/

export const setClass = params => Http.post(`${baseUrl}/class`, params )

/**
 * 修改班级
 * @param params
 * 
*/

export const editClass = params => Http.put(`${baseUrl}/class`, params )

/**
 * 删除班级
 * @param classId
 * 
*/

export const delClass = classId => Http.delete(`${baseUrl}/class/${classId}` )

/**
 * 班级排序
 * @param params
 * 
*/

export const sortClass = params => Http.put(`${baseUrl}/class/sort`, params )

/**
 * 班级详情
 * @param id
 * 
*/

export const classInfo = id => Http.get(`${baseUrl}/class/${id}` )

/**
 * 修改聊天室状态
 * @param classId
 * 
*/

export const editChatState = classId => Http.put(`${baseUrl}/class/${classId}/chatState` )

/**
 * 班级权重详情
 * @param classId
 * 
*/

export const classWeightInfo = classId => Http.get(`${baseUrl}/class/weight/${classId}` )

/**
 * 配置班级权重
 * @param params
 * 
*/

export const setClassWeight = params => Http.post(`${baseUrl}/class/weight`, params )

/**
 * 验证是否所有学员已加入团队
 * @param classId
 * 
*/

export const allJoinTeam = classId => Http.get(`${baseUrl}/class/user/${classId}/allJoinTeam` )
